import { render, staticRenderFns } from "./admingroups.vue?vue&type=template&id=4042f583&scoped=true&"
import script from "./admingroups.vue?vue&type=script&lang=js&"
export * from "./admingroups.vue?vue&type=script&lang=js&"
import style0 from "./admingroups.vue?vue&type=style&index=0&id=4042f583&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4042f583",
  null
  
)

export default component.exports